import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import React from 'react';
import { Button } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { shouldDisableNextNavigation } from '~/Components/Pagination/paginationHelper';

interface PaginationProps {
  pageSize: number;
  page?: number;
  currentListLength: number;
  onNextPage: () => void;
  onPreviousPage: () => void;
  isDisabled?: boolean;
  hasNPlusOne?: boolean;
  pageStartValue?: number;
  total?: number;
}

const useStyles = makeStyles(() => ({
  PaginationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  PaginationButton: {
    minWidth: 50,
    maxWidth: 50,
    height: 50,
    borderRadius: 50,
  },
}));

export const Pagination = ({
  pageSize,
  page = 1,
  currentListLength,
  onNextPage,
  onPreviousPage,
  isDisabled,
  hasNPlusOne = false,
  pageStartValue = 1,
  total,
}: PaginationProps) => {
  const { classes } = useStyles();
  const disableBackNavigation = page === pageStartValue;

  const isNextNavigationDisabled = shouldDisableNextNavigation({
    hasNPlusOne,
    currentListLength,
    pageSize,
    total: Number(total),
    page,
  });

  if (disableBackNavigation && isNextNavigationDisabled) {
    return null;
  }
  return (
    <div className={classes.PaginationContainer}>
      <Button
        className={classes.PaginationButton}
        onClick={onPreviousPage}
        disabled={!!isDisabled || disableBackNavigation}
      >
        <ChevronLeft />
      </Button>
      {page}
      <Button
        className={classes.PaginationButton}
        onClick={onNextPage}
        disabled={!!isDisabled || isNextNavigationDisabled}
      >
        <ChevronRight />
      </Button>
    </div>
  );
};
